import React from "react";

const STEP_ICONS = {
  setup: "fas fa-sliders-h",
  groups: "fas fa-layer-group",
  "groups-visits": "fas fa-layer-group",
  visits: "fas fa-calendar-day",
  publish: "fas fa-rocket",
  activity: "fas fa-history",
};

/** QMS publish-stepper layout — circle nodes + connector lines */
export default function ScheduleStepper({
  steps,
  activeIndex,
  maxReachable,
  onStepClick,
}) {
  return (
    <nav className="schedule-qms-stepper__track" aria-label="Schedule setup steps">
      {steps.map((step, index) => {
        const isActive = index === activeIndex;
        const isComplete = index < activeIndex;
        const isActivity = step.id === "activity";
        const isReachable =
          isActivity ||
          index <= maxReachable ||
          index === activeIndex + 1 ||
          index < activeIndex;
        const connectorComplete = index < activeIndex;

        return (
          <React.Fragment key={step.id}>
            <button
              type="button"
              className={`schedule-qms-stepper__node${
                isActive ? " is-active" : ""
              }${isComplete ? " is-complete" : ""}`}
              disabled={!isReachable}
              onClick={() => isReachable && onStepClick?.(index)}
            >
              <span className="schedule-qms-stepper__node-circle" aria-hidden="true">
                {isComplete ? (
                  <i className="fas fa-check" aria-hidden="true" />
                ) : (
                  <i className={STEP_ICONS[step.id] || "fas fa-circle"} aria-hidden="true" />
                )}
              </span>
              <span className="schedule-qms-stepper__node-label">{step.label}</span>
            </button>

            {index < steps.length - 1 ? (
              <div
                className={`schedule-qms-stepper__connector${
                  connectorComplete ? " is-complete" : ""
                }${isActive ? " is-current" : ""}`}
                aria-hidden="true"
              >
                <span className="schedule-qms-stepper__connector-line" />
              </div>
            ) : null}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
